import moment from "moment";
import { HolidayRule } from "../models/HolidayRule";

export function getHolidayDateRangeForRule(
  rule: HolidayRule,
  year: number,
): { startDate: string; endDate: string } {
  const override = rule.holidayOverrides?.find((o) => o.year === year);

  // If override contains explicit offsets, apply them
  const baseDateStr =
    rule.date?.replace(/^\\d{4}/, year.toString()) ??
    rule.holiday?.dates.find((d) => d.startsWith(`${year}`));

  if (!baseDateStr) {
    return { startDate: "", endDate: "" };
  }

  const baseDate = moment(baseDateStr);

  const startDate = override
    ? baseDate.clone().add(override.startOffsetMinutes, "minutes")
    : baseDate.clone().add(rule.startOffsetMinutes, "minutes");

  const endDate = override
    ? baseDate.clone().add(override.endOffsetMinutes, "minutes")
    : baseDate.clone().add(rule.endOffsetMinutes, "minutes");

  return {
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  };
}
